// The power hour bar from design/project/App09p-PowerHourLobby: shown in the lobby in place of "Choose your arena"
// while battles pay half the fee, with the time left.
import { useGame, useTicker } from "../game.js";

export function PowerBanner({ endsAt }: { endsAt: number }) {
  const { now } = useGame();
  useTicker(1000);
  const left = Math.max(0, endsAt - now());
  const clock = `${Math.floor(left / 60_000)}:${String(Math.floor((left % 60_000) / 1000)).padStart(2, "0")}`;
  return (
    <div role="status" style={{ flexShrink: 0, height: "34px", boxSizing: "border-box", padding: "0 6px 0 12px", borderRadius: "12px", background: "linear-gradient(90deg, rgba(204,255,0,0.22), rgba(255,51,102,0.18))", border: "1px solid rgba(204,255,0,0.55)", display: "flex", alignItems: "center", gap: "8px" }}>
      <svg width="16" height="16" viewBox="0 0 24 24" style={{ flex: "none" }} aria-hidden="true"><path d="M13 2 L4 14 H11 L10 22 L20 9 H13 Z" fill="#CCFF00"></path></svg>
      <span style={{ fontFamily: "Unbounded, sans-serif", fontWeight: "900", fontSize: "11px", letterSpacing: "0.06em", whiteSpace: "nowrap" }}>POWER HOUR</span>
      <span style={{ flex: "1", minWidth: "0", fontSize: "12px", color: "#C9D1D9", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>half fees</span>
      <span style={{ flex: "none", height: "24px", padding: "0 8px", borderRadius: "8px", background: "#0B0E14", display: "flex", alignItems: "center", fontFamily: "'JetBrains Mono', monospace", fontWeight: "800", fontSize: "12px", color: "#CCFF00" }}>{clock}</span>
    </div>
  );
}
